import {
  Button,
  Card,
  Modal,
  Stack,
  Switch,
  TextField,
  Typography,
  CardContent,
  CardActions,
  useTheme,
  Grid,
  useMediaQuery,
  Box,
  IconButton,
  Icon,
  ListItem,
  ListItemText,
  FormControl,
  Select,
  MenuItem,
  ListItemButton,
  ListItemAvatar,
  Avatar,
  List
} from "@mui/material";
import React from "react";
import { BIBlue } from "../../assets/helpers";
import HelpIcon from "@mui/icons-material/Help";
import {
  AccountCircleRounded,
  ArrowDownwardRounded,
  ArrowUpward,
  Email
} from "@mui/icons-material";
import { useSelector } from "react-redux";
import { English } from "../../constant/EnglishFallback";
import EditIcon from "@mui/icons-material/Edit";

const CarpoolTutorial = (props) => {
  const { multiLanguageData } = useSelector((state) => state?.main);
  const LanguageData = multiLanguageData?.Carpool || {};

  const {
    TEXT_CARPOOL_HEADER = English.Carpool.TEXT_CARPOOL_HEADER,
    TEXT_TUTORIAL_PAGE1_LINE1 = English.Carpool.TEXT_TUTORIAL_PAGE1_LINE1,
    TEXT_TUTORIAL_PAGE1_LINE2 = English.Carpool.TEXT_TUTORIAL_PAGE1_LINE2,
    TEXT_TUTORIAL_PAGE1_LINE3 = English.Carpool.TEXT_TUTORIAL_PAGE1_LINE3,
    TEXT_INTERESTED_IN_CARPOOL = English.Carpool.TEXT_INTERESTED_IN_CARPOOL,
    TEXT_TUTORIAL_PAGE2_LINE1 = English.Carpool.TEXT_TUTORIAL_PAGE2_LINE1,
    TEXT_TUTORIAL_PAGE3_LINE1 = English.Carpool.TEXT_TUTORIAL_PAGE3_LINE1,
    TEXT_TUTORIAL_PAGE3_LINE2 = English.Carpool.TEXT_TUTORIAL_PAGE3_LINE2,
    TEXT_TUTORIAL_PAGE3_LINE3 = English.Carpool.TEXT_TUTORIAL_PAGE3_LINE3,
    TEXT_TUTORIAL_PAGE4_LINE1 = English.Carpool.TEXT_TUTORIAL_PAGE4_LINE1,
    TEXT_MESSAGE = English.Carpool.TEXT_MESSAGE,
    TEXT_KM_AWAY = English.Carpool.TEXT_KM_AWAY,
    TEXT_CONTACTS_WITHIN_5_KM = English.Carpool.TEXT_CONTACTS_WITHIN_5_KM,
    TEXT_OTHERS_WITHIN_5_KM = English.Carpool.TEXT_OTHERS_WITHIN_5_KM,
    TEXT_MY_ADDRESS = English.Carpool.TEXT_MY_ADDRESS,
    TEXT_CURRENT_SITE = English.Carpool.TEXT_CURRENT_SITE
  } = LanguageData || {};

  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const drawerWidth = 240;

  let others = [
    {
      userId: 1,
      firstName: "Alice",
      lastName: "livam",
      latitude: 51.0447332,
      longitude: -114.0718831,
      myLatitude: 51.0447332,
      myLongitude: -114.0718831,
      isMyContact: false,
      pictureUrl: "https://biappstoragetest2.blob.core.windows.net/userprofiles/AvatarImage.jpg",
      distance: 3.4,
      userTrade: "CabinateMaker ",
      userEmail: "livami3140@sectorid.com"
    },
    {
      userId: 2,
      firstName: "Bob",
      lastName: "lee",
      latitude: 51.0447332,
      longitude: -114.0718831,
      myLatitude: 51.0447332,
      myLongitude: -114.0718831,
      isMyContact: false,
      pictureUrl: "https://biappstoragetest2.blob.core.windows.net/userprofiles/AvatarImage.jpg",
      distance: 4.4,
      userTrade: "Carpenter",
      userEmail: "xolane3770@irnini.com"
    }
  ];
  let contacts = [
    {
      userId: 3,
      firstName: "John",
      lastName: "Smith",
      latitude: 51.0447331,
      longitude: -114.0718831,
      myLatitude: 51.0447332,
      myLongitude: -114.0718831,
      isMyContact: true,
      pictureUrl: "https://biappstoragetest2.blob.core.windows.net/userprofiles/AvatarImage.jpg",
      distance: 1.2,
      userTrade: "Boilmaker",
      userEmail: "john4490@due.com"
    },
    {
      userId: 4,
      firstName: "Jane",
      lastName: "Dae",
      latitude: 51.0447331,
      longitude: -114.0718831,
      myLatitude: 51.0447332,
      myLongitude: -114.0718831,
      isMyContact: true,
      pictureUrl: "https://biappstoragetest2.blob.core.windows.net/userprofiles/AvatarImage.jpg",
      distance: 2.3,
      userTrade: "Bricklayer",
      userEmail: "john4490@due.com"
    }
  ];

  const RenderAvailableusers = (itemList) => {
    return itemList.map((item, index) => (
      <Card key={index.toString()} className="pagelist-content" sx={{ marginTop: "0px" }}>
        <ListItem
          sx={{ m: 0 }}
          key={index.toString()}
          secondaryAction={<Button variant="contained"> {TEXT_MESSAGE}</Button>}
          disablePadding>
          <ListItemButton sx={{ display: "flex", flexDirection: "row", p: 0, pl: 2 }}>
            <ListItemAvatar>
              <Avatar alt="contact-PictureUrl" src={item?.pictureUrl} />
            </ListItemAvatar>

            <ListItemText
              primary={
                <Typography variant="body1" maxWidth={"430px"} noWrap>
                  {item?.firstName} {item?.lastName}
                </Typography>
              }
              secondary={
                <Box>
                  <Typography variant="body2" maxWidth={"430px"} noWrap>
                    {item?.userTrade}
                  </Typography>
                  <Typography variant="body2" maxWidth={"430px"} noWrap>
                    {`${item?.distance} ${TEXT_KM_AWAY}`}
                  </Typography>
                </Box>
              }
            />
          </ListItemButton>
        </ListItem>
      </Card>
    ));
  };

  return (
    <Modal open={props?.tutorialIndex === 0 ? false : true}>
      <Box sx={{ backgroundColor: "rgba(0, 0, 0, 0.7)", height: "100%" }} onClick={props.onPress}>
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            height: `calc(100vh - ${theme.mixins.toolbar.minHeight}px)`, // Dynamically set height
            overflowY: "auto",
            mt: `${theme.mixins.toolbar.minHeight}px`, // Push content below AppBar
            width: { sm: props.tutorialIndex === 1 ? "100%" : `calc(100% - ${drawerWidth}px)` }, // Ensure content doesn't go behind Sidebar
            marginLeft: { sm: props.tutorialIndex === 1 ? 0 : `${drawerWidth}px`, xs: 0 }
          }}>
          <Box
            className="main-content-Box"
            sx={{ p: isSmallScreen ? 2 : 3, pt: 2, backgroundColor: "transparent" }}>
            {props.tutorialIndex === 1 && (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100vh"
                }}>
                <Stack sx={{ textAlign: "center", color: "white" }}>
                  <Typography variant="h6">{TEXT_CARPOOL_HEADER}</Typography>
                  <Typography variant="subtitle1">
                    {TEXT_TUTORIAL_PAGE1_LINE1} {TEXT_TUTORIAL_PAGE1_LINE2}
                  </Typography>
                  <Typography variant="body1">
                    <span style={{ color: BIBlue }}> ({TEXT_TUTORIAL_PAGE1_LINE3})</span>
                  </Typography>
                </Stack>
              </Box>
            )}

            <Grid
              pb={1.5}
              container
              spacing={1}
              display={"flex"}
              justifyContent={"space-between"}
              alignItems={"center"}>
              <Grid size={{ xs: 4, sm: 4, md: 4, lg: 4 }}></Grid>
              <Grid
                size={{ xs: 8, sm: 8, md: 5, lg: 5 }}
                sx={{ display: props.tutorialIndex === 2 ? "flex" : "none" }}
                justifyContent={"flex-end"}>
                <Button sx={{ backgroundColor: "white" }} size="small" variant="outlined">
                  <Switch size="small" /> {TEXT_INTERESTED_IN_CARPOOL}
                </Button>
                <IconButton size="small" disabled>
                  <HelpIcon />
                </IconButton>
              </Grid>
            </Grid>
            {props.tutorialIndex === 2 ? (
              <Stack sx={{ display: "flex", alignItems: "flex-end" }}>
                <Stack
                  sx={{
                    width: "300px",
                    display: "flex",
                    alignItems: "center",
                    color: "white"
                  }}>
                  <ArrowUpward />
                  <Typography variant="h6">{TEXT_TUTORIAL_PAGE2_LINE1}</Typography>
                </Stack>
              </Stack>
            ) : (
              <>
                {props.tutorialIndex === 3 ? (
                  <Box sx={{ display: props.tutorialIndex === 3 ? "block" : "none", mt: 4.5 }}>
                    <Grid
                      sx={{
                        height: isSmallScreen ? "auto" : "100%",
                        backgroundColor: "transparent !important"
                      }}
                      container
                      spacing={2}
                      className={"main-content-carpool-card"}>
                      <Grid
                        sx={{ p: 2 }}
                        className="pagelist-content"
                        size={{ xs: 12, sm: 12, md: 4, lg: 4, xl: 4 }}>
                        <ListItem
                          sx={{ padding: 0, ".MuiListItemSecondaryAction-root": { right: 0 } }}
                          disablePadding
                          secondaryAction={
                            <IconButton color="primary">
                              <EditIcon />
                            </IconButton>
                          }>
                          <ListItemText
                            sx={{ m: 0 }}
                            primary={TEXT_MY_ADDRESS}
                            secondary={
                              <Typography variant="body2" width={"80%"} color="textSecondary">
                                {"404 9 Avenue Southwest, Calgary, AB, T2P 4K7, Canada"}
                              </Typography>
                            }
                          />
                        </ListItem>

                        <Stack spacing={1} width={"100%"} display={"flex"}>
                          <Typography variant="body1">{TEXT_CURRENT_SITE}</Typography>

                          <FormControl fullWidth size="small">
                            <Select size="small" value={10}>
                              <MenuItem value={10} style={{ width: "100%" }}>
                                <ListItemText primary={"No Site"} secondary={""} />
                              </MenuItem>
                            </Select>
                          </FormControl>
                        </Stack>
                      </Grid>
                      <Box sx={{ display: props.tutorialIndex === 4 ? "block" : "none", mt: 4.5 }}>
                        <Grid
                          sx={{ p: 2, height: "100%", overflowY: "auto", scrollbarWidth: "none" }}
                          className="pagelist-content"
                          size={{ xs: 12, sm: 12, md: 8, lg: 8, xl: 8 }}></Grid>
                      </Box>
                      <Grid size={{ xs: 12 }}>
                        <Stack sx={{ display: "flex", alignItems: "flex-start" }}>
                          <Stack
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              color: "white"
                            }}>
                            <ArrowUpward />
                            <Typography variant="subtitle1" style={{ color: "white" }}>
                              {TEXT_TUTORIAL_PAGE3_LINE1} {TEXT_TUTORIAL_PAGE3_LINE2}
                            </Typography>
                            <Typography variant="subtitle1" style={{ color: "white" }}>
                              {TEXT_TUTORIAL_PAGE3_LINE3}
                            </Typography>
                          </Stack>
                        </Stack>
                      </Grid>
                    </Grid>
                  </Box>
                ) : (
                  <Box
                    sx={{
                      display: props.tutorialIndex === 4 ? "block" : "none",
                      mt: { xs: 23, sm: 25, md: 4.5 }
                    }}>
                    <Grid
                      sx={{
                        height: isSmallScreen ? "auto" : "100%",
                        backgroundColor: "transparent !important"
                      }}
                      container
                      spacing={2}
                      className={"main-content-carpool-card"}>
                      <Grid size={{ xs: 12, sm: 12, md: 4, lg: 4, xl: 4 }}> </Grid>

                      <Grid
                        sx={{ p: 2, height: "100%", overflowY: "auto", scrollbarWidth: "none" }}
                        className="pagelist-content"
                        size={{ xs: 12, sm: 12, md: 8, lg: 8, xl: 8 }}>
                        <List disablePadding>
                          {contacts.length != 0 ? (
                            <>
                              <Typography p={1} variant="h6">
                                {TEXT_CONTACTS_WITHIN_5_KM}
                              </Typography>
                              <Stack gap={1}>{RenderAvailableusers(contacts)}</Stack>
                            </>
                          ) : null}
                          {others.length != 0 ? (
                            <>
                              <Typography p={1} variant="h6">
                                {TEXT_OTHERS_WITHIN_5_KM}
                              </Typography>
                              <Stack gap={1}>{RenderAvailableusers(others)}</Stack>
                            </>
                          ) : null}
                        </List>
                      </Grid>
                    </Grid>
                    <Grid size={{ xs: 12 }}>
                      <Stack sx={{ display: "flex", alignItems: "flex-end" }}>
                        <Stack
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            color: "white",
                            pt: 2,
                            pr: 5
                          }}>
                          <ArrowUpward />
                          <Typography variant="subtitle1" style={{ color: "white" }}>
                            {TEXT_TUTORIAL_PAGE4_LINE1}
                          </Typography>
                        </Stack>
                      </Stack>
                    </Grid>
                  </Box>
                )}
              </>
            )}
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default CarpoolTutorial;
